import { render, staticRenderFns } from "./projectOutRecords2.vue?vue&type=template&id=1b41c534&"
import script from "./projectOutRecords2.vue?vue&type=script&lang=js&"
export * from "./projectOutRecords2.vue?vue&type=script&lang=js&"
import style0 from "./projectOutRecords2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "projectOutRecords2.vue"
export default component.exports